/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_ApprovalsInputs */

const en_mk_mx_approvals = /** @type {(inputs: Mk_Mx_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval before outbound actions`)
};

const id_mk_mx_approvals = /** @type {(inputs: Mk_Mx_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval sebelum aksi keluar`)
};

/**
* | output |
* | --- |
* | "Approval before outbound actions" |
*
* @param {Mk_Mx_ApprovalsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_approvals = /** @type {((inputs?: Mk_Mx_ApprovalsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_ApprovalsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_approvals(inputs)
	return en_mk_mx_approvals(inputs)
});